import { render } from "./LastCard.vue?vue&type=template&id=c1ff5598"
import script from "./LastCard.vue?vue&type=script&lang=js"
export * from "./LastCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__